import { Col, Row, Form, Breadcrumb, Tabs } from "antd";
import { useMutation } from "react-query";
import { useEffect, useState } from "react";
import GeneralInformation from "./GeneralInformation";
import AddressInformation from "./AddressInformation";
import ContactInformation from "./ContactInformation";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CancelBtn from "../UI/CancelButton/CancelBtn";
import { createCustomer, editCustomer } from "../../api/customers";
import { customerType } from "./CustomerType";
import "./customers.css";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import PreviousButton from "../UI/PreviousButton/previousbutton";
import NextButton from "../UI/NextButton/nextbutton";
import AddEditButton from "../UI/AddEditButton/addeditbutton";
import AddEditModal from "../UI/ModalComponent/AddEditModal/addeditcomponent";
import { getCurrencyById } from "../../api/setting";
import { message } from "antd";
import { getCountriesDropdown } from "../../api/countries";
import { useQuery } from "react-query";
export interface Option {
  id: number;
  value: string;
}

function AddEditCustomer() {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [t] = useTranslation("common");
  const [form] = Form.useForm();
  const [key, setKey] = useState("1");
  const { id } = useParams();
  const navigate = useNavigate();
  const customer = location?.state?.customer;
  const formatedContactType = location?.state?.formatedContactType;
  const loadingContactType = location?.state?.loadingContactType;
  const formatedCountries = location?.state?.formatedCountries;
  const loadingCountries = location?.state?.loadingCountries;

  const [, setFullName] = useState("");
  const [isFullNameValid, setIsFullNameValid] = useState(false);
  const [, setFullNameErrorMessage] = useState("");
  const [, setIsAddDisabled] = useState(false);
  const [selectedContactType, setSelectedContactType] = useState<any>(null);
  const [selectedCountry, setSelectedCountry] = useState<any>(null);
  const [phoneNumber, setPhoneNumber] = useState(false);
  const [customerPhoneNumber] = useState<string[]>(
    customer?.phone?.split("/") || ["+961", ""]
  );
  const [customerMobileNumber] = useState<string[]>(
    customer?.mobile?.split("/") ?? ["+961", ""]
  );
  const [, setIsPostalCodeValid] = useState(false);
  const isEdit = () => {
    return !!id;
  };
  const [editStatus] = useState(isEdit());

  const [formatedCountryPhone, setFormatedCountryPhone] = useState<{}[]>();
  useQuery("countries", getCountriesDropdown, {
    refetchOnWindowFocus: false,
    onSuccess: (res: any) => {
      const formattedCountryData = res.data?.map((country: any) => {
        return {
          value: country.areaCode,
          label: (
            <>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <img style={{ width: 15, height: 15, marginRight: '0.3rem' }} src={`/flags/${country.abbreviation}.svg`} />
                {country.areaCode}
              </div>
            </>
          ),
        };
      });
      const uniqueFormattedCountryData = Array.from(
        new Set(formattedCountryData.map((country: any) => country.value))
      ).map((areaCode) =>
        formattedCountryData.find((country: any) => country.value === areaCode)
      );

      setFormatedCountryPhone(uniqueFormattedCountryData);
    },
  });

  useEffect(() => {
    if (editStatus) {
      setIsFullNameValid(true);
      setIsPostalCodeValid(true);
      setIsAddDisabled(true);
      setSelectedContactType(true);
      setSelectedCountry(true);
      setPhoneNumber(true);
    }
  }, [editStatus]);

  useEffect(() => {
    const lebanon = formatedCountries?.find(
      (country: any) => country.label === "Lebanon"
    );
    if (lebanon) setSelectedCountry(lebanon);
  }, [])

  const items = [
    {
      key: "1",
      label: `${t("general-information")}`,

      children: (
        <GeneralInformation
          setFullName={setFullName}
          setIsFullNameValid={setIsFullNameValid}
          setFullNameErrorMessage={setFullNameErrorMessage}
          loadingContactType={loadingContactType}
          formatedContactType={formatedContactType}
          setSelectedContactType={setSelectedContactType}
          customer={customer}
          isEdit={isEdit}
        />
      ),
    },
    {
      key: "2",
      label: `${t("address-information")}`,
      children: (
        <AddressInformation
          formatedCountries={formatedCountries}
          loadingCountries={loadingCountries}
          setSelectedCountry={setSelectedCountry}
          selectedCountry={selectedCountry}
        />
      ),

      disabled: !isFullNameValid || !selectedContactType,
    },
    {
      key: "3",
      label: `${t("contact-information")}`,
      children: (
        <ContactInformation
          customer={customer}
          setPhoneNumber={setPhoneNumber}
          formatedCountryPhone={formatedCountryPhone}
        />
      ),
      disabled: !selectedCountry,
    },
  ];
  const [activeTabLabel, setActiveTabLabel] = useState(items[0].label);

  const updateActiveTabLabel = (activeKey: string) => {
    const activeItem = items.find((item) => item.key === activeKey);
    if (activeItem) {
      setActiveTabLabel(activeItem.label);
    } else {
      setActiveTabLabel("");
    }
  };

  const onChange = (key: string) => {
    setKey(key);
    updateActiveTabLabel(key);
  };

  const handleNext = () => {
    const nextKey = (parseInt(key) + 1).toString();
    setKey(nextKey);
    updateActiveTabLabel(nextKey);
  };

  const handlePrevious = () => {
    const previousKey = (parseInt(key) - 1).toString();
    setKey(previousKey);
    updateActiveTabLabel(previousKey);
  };
  const [, setError] = useState<any>();

  const onError = (error: any, variables: customerType, context: unknown) => {
    let errorMessage = "An error occurred";

    if (error.response?.data?.errors?.[0]?.msg) {
      const errorData = error.response.data.errors[0];
      errorMessage = `${errorData.param} ${errorData.msg}`;
    } else if (error.response?.data?.message) {
      errorMessage = error.response.data.message;
    } else {
      errorMessage = error.message;
    }

    if (setError) {
      setError(errorMessage);
    }

    message.error({
      content: errorMessage,
      duration: 10,
      onClick: () => {
        message.destroy();
      },
    });
  };

  const { mutateAsync: mutateCreateUpdate, isLoading: isSaving } = useMutation(
    !isEdit() ? "createCustomr" : "editCustomer",
    !isEdit()
      ? (customer: customerType) => createCustomer(customer)
      : (customer: customerType) => editCustomer(id, customer),
    {
      onSuccess: (res) => {
        navigate("/customers");
        message.success("Complete successfully");
      },
      onError,
    }
  );
  const handleFinish = async () => {
    const newcustomer = form.getFieldsValue();
    for (const key in newcustomer) {
      if (newcustomer[key] === undefined) {
        if (key === "isActive") {
          newcustomer[key] = true;
        } else {
          newcustomer[key] = null;
        }
      } else if (
        typeof newcustomer[key] === "string" &&
        newcustomer[key].trim() === ""
      ) {
        newcustomer[key] = null;
      }
    }
    newcustomer.dob = newcustomer.dob
      ? dayjs(newcustomer.dob).format("MM/DD/YYYY HH:mm:ss")
      : null;

    const currencyResponse = await getCurrencyById();
    const settingCurrency = currencyResponse.data;
    newcustomer.curId = settingCurrency.id;
    if (newcustomer.phone)
      newcustomer.phone = `${newcustomer.areaCodePhone}/${newcustomer.phone}`;
    else newcustomer.phone = null;
    if (newcustomer.mobile)
      newcustomer.mobile = `${newcustomer.areaCodeMobile}/${newcustomer.mobile}`;
    else newcustomer.mobile = null;

    newcustomer.countryId = newcustomer.countryId ?? customer?.country?.id;

    mutateCreateUpdate(newcustomer);
  };

  const isValid = dayjs(customer?.dob, "MM/DD/YYYY HH:mm:ss").isValid();

  return (
    <>
      <Row>
        <Col
          offset={1}
          span={20}
          style={{
            marginBottom: "10px",
          }}
        >
          <Breadcrumb
            items={[
              {
                title: <Link to="/main">{t("home")}</Link>,
              },
              {
                title: <>{t("sales")}</>,
              },
              {
                title: <Link to="/customers">{t("customers-list")}</Link>,
              },
              {
                title: (
                  <>
                    {" "}
                    {isEdit()
                      ? `${t("edit-customer")}`
                      : `${t("add-customer")}`}
                  </>
                ),
              },
              {
                title: (
                  <span className="breadcrumbcolor">{activeTabLabel}</span>
                ),
              },
            ]}
          />
        </Col>

        {isEdit() ? (
          <Col className="editTitle" offset={1} span={20}>
            {customer?.name}
          </Col>
        ) : (
          <Col className="editTitle" offset={1} span={20}>
            {t("add-customer")}
          </Col>
        )}

        <Row style={{ minHeight: "70vh" }}>
          <Col offset={1} span={22}>
            <Form
              id="customerform"
              form={form}
              onFinish={handleFinish}
              onError={() => { }}
              layout="vertical"
              style={{ margin: "auto" }}
              initialValues={{
                countryId: customer?.country?.id,
                city: customer?.city,
                addressLine1: customer?.addressLine1,
                addressLine2: customer?.addressLine2,
                postalCode: customer?.postalCode,
                typeId: customer?.type?.id,
                abbreviation: customer?.abbreviation,
                name: customer?.name,
                notes: customer?.notes,
                dob: isValid
                  ? dayjs(customer?.dob, "MM/DD/YYYY HH:mm:ss")
                  : dayjs(),
                email: customer?.email,
                areaCodePhone: customerPhoneNumber[0],
                phone: customerPhoneNumber[1],
                areaCodeMobile: customerMobileNumber[0],
                mobile: customerMobileNumber[1],
                isActive: isEdit() ? customer?.isActive : true,
                curId:
                  customer?.curr.id ||
                  JSON.parse(localStorage.getItem("mainCurrency") || "")?.id,
              }}
            >
              <Tabs
                className="ant-tab"
                defaultActiveKey="1"
                activeKey={key}
                items={items}
                onChange={onChange}
                data-testid="tabs-test"
              />
            </Form>
          </Col>
        </Row>

        <Col offset={1} span={4}>
          <CancelBtn data-testid="cancel-button" />
        </Col>
        <Col
          offset={16}
          span={2}
          style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}
        >
          <PreviousButton
            onClick={() => handlePrevious()}
            disabled={key === "1"}
            data-testid="previous-button"
          />

          {key !== "3" ? (
            <Col style={{ display: "flex", justifyContent: "flex-end" }}>
              {key === "1" && (
                <NextButton
                  disabled={!isFullNameValid || !selectedContactType}
                  onClick={() => handleNext()}
                />
              )}
              {key === "2" && (
                <NextButton
                  disabled={!selectedCountry}
                  onClick={() => handleNext()}
                />
              )}
            </Col>
          ) : (
            <Col style={{ display: "flex", justifyContent: "flex-end" }}>
              <AddEditButton
                onClick={() => {
                  setOpen(true);
                }}
                disabled={isSaving}
                isLoading={""}
              />
            </Col>
          )}
        </Col>
      </Row>
      <AddEditModal
        form="customerform"
        open={open}
        setOpen={setOpen}
        name={<span> {customer?.name}</span>}
        title={`${t("custome")}`}
        isSaving={isSaving}
      />
    </>
  );
}

export default AddEditCustomer;
